"use client";
import clsx from "clsx";
import { StaticImageData } from "next/image";

import { Column } from "@/components/containers";

import { useProductImages } from "./hooks/useProductImages";
import styles from "./ProductImages.module.scss";
import { ProductMainImage } from "./ProductMainImage";
import { SliderButton } from "./SliderButton";
import { ThumbnailImages } from "./ThumbnailImages";

export interface ProductImagesProps {
  imageSrcs: (StaticImageData | string)[];
}

export function ProductImages({ imageSrcs }: ProductImagesProps): React.ReactNode {
  const {
    isCursorDisabled,
    changeMainImage,
    nextThumbnailGroup,
    prevThumbnailGroup,
    currentSelectedImage,
    startIndex,
    endIndex,
  } = useProductImages({ imageSrcs });

  return (
    <Column>
      <ProductMainImage imageSrc={currentSelectedImage} />

      {/* PC版は全てのサムネイルを表示する */}
      <div className={clsx(styles.thumbnailsContainer, styles.hideSP)}>
        <ThumbnailImages imageSrcs={imageSrcs} onClick={changeMainImage} />
      </div>

      {/* SP版はページ単位でサムネイルを表示する */}
      <div className={clsx(styles.thumbnailsContainer, styles.hidePC)}>
        <SliderButton
          isCursorDisabled={isCursorDisabled}
          isRight={false}
          onClick={prevThumbnailGroup}
          classNames={clsx(styles.sliderPrev)}
        />

        <ThumbnailImages
          imageSrcs={imageSrcs}
          startIndex={startIndex}
          endIndex={endIndex}
          onClick={changeMainImage}
        />

        <SliderButton
          isCursorDisabled={isCursorDisabled}
          isRight={true}
          onClick={nextThumbnailGroup}
          classNames={clsx(styles.sliderNext)}
        />
      </div>
    </Column>
  );
}
